import { createSlice, 
    // PayloadAction
 } from '@reduxjs/toolkit'

interface drawerState {
    open: boolean
}
const initialDrawerState = {
    open: window.innerWidth > 600,
} as drawerState;

export const drawerSlice = createSlice({
    name: 'drawer',
    initialState: initialDrawerState,
    reducers: {
        open: (state) => {
            state.open = true
        },
        close: (state) => {
            state.open = false
        },
        toggle: (state) => {
            state.open = ! state.open
        }
    },
})

export const { open, close, toggle } = drawerSlice.actions;
export default drawerSlice.reducer;
